import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import ButtonOutlined from '../../shared/Buttons/ButtonOutlined';
import useGeneralDialog from '../../../hooks/dialogs/useGeneralDialog';
import { QuotationAddNewProduct } from './add-new-product-modal/QuotationAddNewProduct';

export const QuotationAddNewProductButton: React.FC<{
    quotationId: number;
    handleUpdateProducts: () => void;
}> = ({ quotationId, handleUpdateProducts }) => {
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR',
    });
    const generalDialog = useGeneralDialog();

    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleAddNewProduct = useCallback((): void => {
        generalDialog.showDialog(
            {
                title: t('ADD_PRODUCT_DIALOG.TITLE'),
                closeLabel: t('ADD_PRODUCT_DIALOG.CLOSE'),
                preSetContent: { quotationId: quotationId },
                component: QuotationAddNewProduct,
                onCloseWithSuccess: handleUpdateProducts,
            },
            'md'
        );
    }, []);

    return (
        <Box sx={{ margin: '12px 0' }}>
            <ButtonOutlined
                onClick={handleAddNewProduct}
                sx={{
                    width: isMobile ? '100%' : 'fit-content',
                    '@media (max-width: 600px)': {
                        fontSize: '12px',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                    },
                }}
            >
                {t('ADD_PRODUCT')}
            </ButtonOutlined>
        </Box>
    );
};
